


















import GetAcceptLogo from '@getaccept/lib-ui/src/assets/img/getaccept-logo-blue-text.svg';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  components: {
    GetAcceptLogo,
  },
  props: {
    logo: {
      type: String,
      default: undefined,
    },
  },
});
